export default __webpack_public_path__ + "static/media/logo.fb99ebda.png";